import { Component, Injectable, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { format, startOfWeek, endOfWeek, addDays, subWeeks, addWeeks, subMonths, addMonths, endOfMonth, subMinutes, isBefore, startOfMonth, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';
import { Observable, Subscription } from 'rxjs';
import { DeviceService } from 'src/app/services/device.service';
import { PDFDocument, PDFPage, rgb, StandardFonts } from 'pdf-lib';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Error429Service } from 'src/app/services/error429.service';
import { UserDataService } from 'src/app/services/user-data.service';
import { MatTabChangeEvent } from '@angular/material/tabs';
interface Cervezas{
  value: number;
  name: string;
}
@Component({
  selector: 'app-mercado-canalejas',
  templateUrl: './mercado-canalejas.component.html',
  styleUrls: ['./mercado-canalejas.component.css']
})
export class MercadoCanalejasComponent implements OnInit, OnDestroy{

  fechaActualD = this.formatearFechaD(new Date());
  fechaActualS :string = "";
  fechaActualM :string = "";
  meses = [
    "ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO",
    "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"
  ];
  mesesPdf = [
    "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
  ];
  errorMessage : string =""; //Mensaje de error
  establishmentData: any = []; //Información de los establecimientos
  mercadoCanalejasDevices: any = []; //Dispositivos del mercado canalejas
  devicesReferences: string = "";
  online: string = "offline";
  litrosConsumidosPorDispositivo: { [key: string]: number | undefined } = {};
  inicioSemana: string = "";
  finSemana: string = "";
  inicioMes: string = "";
  finMes: string = "";
  //Variables para ver que fecha escribir en el pdf
  diario: boolean = true;
  semanal: boolean = false;
  mensual: boolean = false;

   /*-------------------------------Seleccionar fecha personalizada------------------------------------------*/
  fechaActual: Date = new Date();
  dia: number = this.fechaActual.getDate(); // Obtener el día del mes actual
  mes: number = this.fechaActual.getMonth(); // Los meses comienzan en 0, por lo que enero es 0 y diciembre es 11)
  anio: number = this.fechaActual.getFullYear(); // Obtener el año actual
  selectedDate = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  fechaActualPersonalizada = this.formatDateToString(this.fechaActual);
  startPersonalizado: string = "";
  endPersonalizado: string = "";
  fechaPersonalizada: boolean = false;
  fechaPersonalizadaError: boolean = false;
  startPersonalizadoError: boolean = false;
  endPersonalizadoErrro: boolean = false;

  cervezas: Cervezas[] = []
  cervezasControl: FormControl = new FormControl();

  //CONSUMO DIA ACTUAL
  consumoDiaActual: any = [];

  //ACTUALIZAR LA PÁGINA
  currentTabIndex: number = 0;
  intervalId: any;
  startActualizar: string = "";
  endActualizar: string = "";
  actualizar: boolean = false;
  consumoTotal: number | undefined = undefined;

  //Subscriptions
  private establishmentSubscription: Subscription | undefined;
  private historicoDiaSubscription: Subscription | undefined;
  private historicoSemanaSubscription: Subscription | undefined;
  private historicoMesSubscription: Subscription | undefined;
  private beerTypesSubscription: Subscription | undefined;

  @Input() userId: any;
  userData: any = [];
  
  constructor(private deviceService: DeviceService, private router: Router, private error429: Error429Service,
    private formBuilder: FormBuilder, private userDataService: UserDataService){
      this.userData = this.userDataService.getUserData();
    }

  ngOnInit(): void {
    // Suscribirse a los eventos valueChanges de start y end de la fechaPersonalizada
    this.selectedDate.get('start')?.valueChanges.subscribe((value) => {
      this.startPersonalizado = this.formatDateToString(value);
    });
    this.selectedDate.get('end')?.valueChanges.subscribe((value) => {
      this.endPersonalizado = this.formatDateToString(value);
    });
    //ESTABLECIMIENTOS
    this.establishmentSubscription = this.deviceService.getDevicesDataNew().subscribe({
      next:resp =>{
        this.establishmentData = resp;
        for(let i=0; i<this.establishmentData.length; i++){
          if (this.establishmentData[i].dev_cliente_id == 6){
            this.mercadoCanalejasDevices.push(this.establishmentData[i]);
            /*if(i<=this.establishmentData.length-1){
              this.devicesReferences += this.establishmentData[i].dev_reference + '-';
            } else{
              this.devicesReferences += this.establishmentData[i].dev_reference;
            }*/
          /*if (this.establishmentData[i].est_name == "Mercado Canalejas"){
            for(let j=0; j<this.establishmentData[i].devices.length; j++){
              this.mercadoCanalejasDevices.push(this.establishmentData[i].devices[j]);
            }
          }*/
          }
        }
        const references: string[] = this.mercadoCanalejasDevices.map((item: { dev_reference: string }) => item.dev_reference);
        const devicesReferences = references.join('-');
        this.devicesReferences = devicesReferences;
      },error:err =>{
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete: () =>{
        //console.log(this.parseJSONOptions(this.mercadoCanalejasDevices[0].options[0].dev_option_value));
        //Se consiguen los litros del día actual ya que es lo primero que se muestra
        this.litrosConsumidosDia();
      }
    });
    //TIPOS DE CEVEZA
    this.cervezasControl = this.formBuilder.control([]);
    this.beerTypesSubscription = this.deviceService.getBeerType().subscribe({
      next:resp =>{
        this.cervezas = resp.map((item: any) => ({ value: item.id, name: item.name }));
      }
    });
    //ACTUALIZAR LOS DATOS
    this.intervalId = setInterval(() => {
      this.actualizar = true;
      //Si se ha seleccionado una fecha calculamos los litros en esa fecha
      if(this.fechaPersonalizada){
        this.litrosConsumidosFechaPersonalizadaConFechas(this.startActualizar, this.endActualizar);
      } else {
        this.onTabFocusChange({ index: this.currentTabIndex });
      }
    }, 30000)
  }

  soloDosDecimalesConComa(numero: number | undefined){
    if(Number.isNaN(numero)){
      return "0";
    } else {
      if(numero == undefined){
        return "0";
      } else {
        return numero.toLocaleString(this.userData.region, { maximumFractionDigits: 2 });
      }
    }
  }

  ngOnDestroy(): void {
    if (this.establishmentSubscription) {
      this.establishmentSubscription.unsubscribe();
    } 
    if (this.historicoDiaSubscription) {
      this.historicoDiaSubscription.unsubscribe();
    }
    if (this.historicoSemanaSubscription) {
      this.historicoSemanaSubscription.unsubscribe();
    }
    if (this.historicoMesSubscription) {
      this.historicoMesSubscription.unsubscribe();
    }
    if (this.beerTypesSubscription) {
      this.beerTypesSubscription.unsubscribe();
    }
    clearInterval(this.intervalId);
  }

  //Se llama cada vez que se cambia el tab
  onTabFocusChange(event: { index: number }) {
    this.currentTabIndex = event.index;
    switch (event.index) {
      case 0: //Diario
        this.litrosConsumidosLoadingGif();
        this.litrosConsumidosDia();
        this.diario = true;
        this.semanal = false;
        this.mensual = false;
        break;
      case 1: //Semanal
        this.diario = false;
        this.semanal = true;
        this.mensual = false;
        if (this.fechaActualD) {
          const fechaConvertida = this.convertirFecha(this.fechaActualD);
          if (fechaConvertida) {
            const fechaActual = fechaConvertida;
            const diaSemana = fechaActual.getDay(); // 0: Domingo, 1: Lunes, ..., 6: Sábado
            const inicioSemana = new Date(fechaActual);
            if(diaSemana==0){
              //Cuando es domingo hay que restarle 6 para que inicioSemana sea Lunes
              inicioSemana.setDate(fechaActual.getDate() - 6); // Inicio de la semana (Lunes)
            } else{
              inicioSemana.setDate(fechaActual.getDate() - (diaSemana-1)); // Inicio de la semana (Lunes)
            }
            const finSemana = new Date(inicioSemana);
            finSemana.setDate(inicioSemana.getDate() + 6); // Fin de la semana (Domingo)
            this.actualizarFechaActualS(finSemana);
            this.litrosConsumidosLoadingGif();
            this.litrosConsumidosSemana();
          } else {
            console.log('Fecha no válida');
          }
        }
        break;
      case 2: //Mensual
        this.calcularMesFechaActualD();
        this.litrosConsumidosLoadingGif();
        this.litrosConsumidosMes();
        this.diario = false;
        this.semanal = false;
        this.mensual = true;
        break;
      default:
        break;
    }
    /*

    if (event.tab.textLabel === 'Diario') {
      this.litrosConsumidosLoadingGif();
      this.litrosConsumidosDia();
      this.diario = true;
      this.semanal = false;
      this.mensual = false;
    }
    if (event.tab.textLabel === 'Semanal') {
      if (this.fechaActualD) {
        const fechaConvertida = this.convertirFecha(this.fechaActualD);
        if (fechaConvertida) {
          const fechaActual = fechaConvertida;
          const diaSemana = fechaActual.getDay(); // 0: Domingo, 1: Lunes, ..., 6: Sábado
          const inicioSemana = new Date(fechaActual);
          if(diaSemana==0){
            //Cuando es domingo hay que restarle 6 para que inicioSemana sea Lunes
            inicioSemana.setDate(fechaActual.getDate() - 6); // Inicio de la semana (Lunes)
          } else{
            inicioSemana.setDate(fechaActual.getDate() - (diaSemana-1)); // Inicio de la semana (Lunes)
          }
          const finSemana = new Date(inicioSemana);
          finSemana.setDate(inicioSemana.getDate() + 6); // Fin de la semana (Domingo)
          this.actualizarFechaActualS(finSemana);
          this.litrosConsumidosLoadingGif();
          this.litrosConsumidosSemana();
        } else {
          console.log('Fecha no válida');
        }
      } else {
        console.log('Fecha actual D es null o no válida');
      }
      this.diario = false;
      this.semanal = true;
      this.mensual = false;
    } 
    if (event.tab.textLabel === 'Mensual') {
      this.calcularMesFechaActualD();
      this.litrosConsumidosLoadingGif();
      this.litrosConsumidosMes();
      this.diario = false;
      this.semanal = false;
      this.mensual = true;
    }*/
  }

  //Función para devolver los litros consumidos de un día
  async litrosConsumidosDia(){
    this.fechaPersonalizada = false;
    //Conseguir día siguiente a fechaactualD
    const diaActual = this.convertirFechaFormato(this.fechaActualD);
    const diaSiguiente = this.obtenerDiaSiguiente(diaActual);
    this.startActualizar = diaActual;
    this.endActualizar = diaSiguiente; 
    const fechaActualPresente = this.verificarDiaActualEnRangoFechas(diaActual,diaActual,this.fechaActualPersonalizada);
    if(fechaActualPresente){
      await this.calcularConsumoDiaActual(diaSiguiente);
    }
    this.historicoDiaSubscription = this.deviceService.getMultiHistoric(this.devicesReferences, diaActual, diaSiguiente,"0").subscribe({
      next:resp =>{
        //console.log(resp);
        for (let i= 0; i < resp.length; i++) {
          let litrosConsumidos = 0;
          if(fechaActualPresente){
            const dispositivo = this.consumoDiaActual.find((dispositivo: any) => dispositivo.deviceId == resp[i].id)
            litrosConsumidos = dispositivo.consumo;
          }
          for (let j= 0; j < resp[i].readers.length; j++) {
            if (resp[i].readers[j] && resp[i].readers[j].field11 !== undefined) {
              litrosConsumidos += parseFloat(resp[i].readers[j].field11 !== null ? resp[i].readers[j].field11 : 0);
            } else {
              litrosConsumidos += 0; //Si el valor es undefined, sumamos 0
            }
            if (resp[i].readers[j] && resp[i].readers[j].field12 !== undefined) {
              litrosConsumidos += parseFloat(resp[i].readers[j].field12 !== null ? resp[i].readers[j].field12 : 0);
            } else {
              litrosConsumidos += 0; //Si el valor es undefined, sumamos 0
            }
            if (resp[i].readers[j] && resp[i].readers[j].field20 !== undefined) {
              litrosConsumidos += parseFloat(resp[i].readers[j].field20 !== null ? resp[i].readers[j].field20 : 0);
            } else {
              litrosConsumidos += 0; //Si el valor es undefined, sumamos 0
            }
          }
          this.litrosConsumidosPorDispositivo[resp[i].dev_reference] = Number(litrosConsumidos.toFixed(2));
        }
      /*for (const device of this.mercadoCanalejasDevices) {
        this.historicoDiaSubscription = this.deviceService.getDeviceHisroticDateTimescale(device.dev_reference,diaActual, diaSiguiente,"0").subscribe({
          next:resp =>{
            if (Array.isArray(resp)) {
              let litrosConsumidos = 0;
              for(let reader of resp){
                litrosConsumidos+=parseFloat(reader.field11 !== null ? reader.field11 : 0);
              }
              this.litrosConsumidosPorDispositivo[device.dev_reference] = Number(litrosConsumidos.toFixed(2));
            } else {
              console.log('Respuesta no válida:', resp);
            }*/
      }, error: err => {
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      },complete: () =>{
        this.calcularLitrosTotales();
      }
    });
  }
  //Función para conseguir los datos históricos de una semana
  async litrosConsumidosSemana(){
    this.fechaPersonalizada = false;
    //Al usar la función actualizarFechaActualS ya se consiguen los valores de finSemana e inicioSemana
    const inicioSemanaISO = this.convertirFechaFormatoISO(this.inicioSemana);
    //Necesario pasar el día siguiente al fín de semana
    const finSemanaISO = this.obtenerDiaSiguiente(this.convertirFechaFormatoISO(this.finSemana));
    this.startActualizar = inicioSemanaISO;
    this.endActualizar = finSemanaISO; 
    //CALCULAR DÍA ACTUAL CON RAW
    const diaActual = this.convertirFechaFormato(this.fechaActualD);
    const diaSiguiente = this.obtenerDiaSiguiente(diaActual);
    const fechaActualPresente = this.verificarDiaActualEnRangoFechas(inicioSemanaISO,finSemanaISO,this.fechaActualPersonalizada);
    if(fechaActualPresente){
      await this.calcularConsumoDiaActual(diaSiguiente);
    }
    this.historicoDiaSubscription = this.deviceService.getMultiHistoric(this.devicesReferences,inicioSemanaISO, finSemanaISO,"0").subscribe({
      next:resp =>{
          for (let i= 0; i < resp.length; i++) {
            let litrosConsumidos = 0;
            //SUMAR CONSUMOS DEL DIA ACTUAL CALCULADOS CON RAW
            if(fechaActualPresente){
              const dispositivo = this.consumoDiaActual.find((dispositivo: any) => dispositivo.deviceId == resp[i].id)
              litrosConsumidos = dispositivo.consumo;
            }
            for (let j= 0; j < resp[i].readers.length; j++) { 
              if (resp[i].readers[j] && resp[i].readers[j].field11 !== undefined) {
                litrosConsumidos += parseFloat(resp[i].readers[j].field11 !== null ? resp[i].readers[j].field11 : 0);
              } else {
                litrosConsumidos += 0; //Si el valor es undefined, sumamos 0
              }
              if (resp[i].readers[j] && resp[i].readers[j].field12 !== undefined) {
                litrosConsumidos += parseFloat(resp[i].readers[j].field12 !== null ? resp[i].readers[j].field12 : 0);
              } else {
                litrosConsumidos += 0; //Si el valor es undefined, sumamos 0
              }
              if (resp[i].readers[j] && resp[i].readers[j].field20 !== undefined) {
                litrosConsumidos += parseFloat(resp[i].readers[j].field20 !== null ? resp[i].readers[j].field20 : 0);
              } else {
                litrosConsumidos += 0; //Si el valor es undefined, sumamos 0
              }
            }
            this.litrosConsumidosPorDispositivo[resp[i].dev_reference] = Number(litrosConsumidos.toFixed(2));
          }
      }, error: err => {
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      },complete: () =>{
        this.calcularLitrosTotales();
      }
    })
  }
  //Función para conseguir los datos históricos de un mes
  async litrosConsumidosMes(){
    this.fechaPersonalizada = false;
    //El día actual al cambiar de mes ya se actualiza al último día del mes y hay que conseguir el siguiente para que tenga en cuenta el último
    const ultimoDiaMes = this.obtenerDiaSiguiente(this.convertirFechaFormato(this.fechaActualD));
    this.finMes = this.fechaActualD;
    const fechaActualFormateada = this.convertirFecha(this.fechaActualD);
    let primerDiaMes: string = "";
    if (fechaActualFormateada) {
      const primerDiaMesF = startOfMonth(fechaActualFormateada);
      const primerDiaMesStr = this.formatearFechaD(primerDiaMesF);
      primerDiaMes = this.convertirFechaFormato(primerDiaMesStr);
      this.inicioMes = primerDiaMesStr;
    }
    this.startActualizar = primerDiaMes;
    this.endActualizar = ultimoDiaMes; 
    //CALCULAR DÍA ACTUAL CON RAW
    const diaActual = this.convertirFechaFormato(this.fechaActualD);
    const diaSiguiente = this.obtenerDiaSiguiente(diaActual);
    const fechaActualPresente = this.verificarDiaActualEnRangoFechas(primerDiaMes,ultimoDiaMes,this.fechaActualPersonalizada);
    //console.log(fechaActualPresente);
    if(fechaActualPresente){
      await this.calcularConsumoDiaActual(diaSiguiente);
    }
    this.historicoDiaSubscription = this.deviceService.getMultiHistoric(this.devicesReferences, primerDiaMes, ultimoDiaMes,"0").subscribe({
      next:resp =>{
        //console.log(resp);
          for (let i= 0; i < resp.length; i++) {
            let litrosConsumidos = 0;
            //SUMAR CONSUMOS DEL DIA ACTUAL CALCULADOS CON RAW
            if(fechaActualPresente){
              const dispositivo = this.consumoDiaActual.find((dispositivo: any) => dispositivo.deviceId == resp[i].id)
              litrosConsumidos = dispositivo.consumo;
            }
            for (let j= 0; j < resp[i].readers.length; j++) {
              if (resp[i].readers[j] && resp[i].readers[j].field11 !== undefined) {
                litrosConsumidos += parseFloat(resp[i].readers[j].field11 !== null ? resp[i].readers[j].field11 : 0);
              } else {
                litrosConsumidos += 0; //Si el valor es undefined, sumamos 0
              }
              if (resp[i].readers[j] && resp[i].readers[j].field12 !== undefined) {
                litrosConsumidos += parseFloat(resp[i].readers[j].field12 !== null ? resp[i].readers[j].field12 : 0);
              } else {
                litrosConsumidos += 0; //Si el valor es undefined, sumamos 0
              }
              if (resp[i].readers[j] && resp[i].readers[j].field20 !== undefined) {
                litrosConsumidos += parseFloat(resp[i].readers[j].field20 !== null ? resp[i].readers[j].field20 : 0);
              } else {
                litrosConsumidos += 0; //Si el valor es undefined, sumamos 0
              }
            }
            this.litrosConsumidosPorDispositivo[resp[i].dev_reference] = Number(litrosConsumidos.toFixed(2));
          }
        }, error: err => {
          if (err.status == 429) {
            this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
            this.recargarPaginaDespuesDeTiempo();
          } else {
            this.errorMessage = err.error.message;
          }
        },complete: () =>{
          this.calcularLitrosTotales();
        }
      })
  }
  //Función para poner todos los valores de litrosConsumidos undefined para cargar el loading gif
  litrosConsumidosLoadingGif(){
    this.consumoTotal = undefined;
    for (const device of this.mercadoCanalejasDevices) {
      this.litrosConsumidosPorDispositivo[device.dev_reference] = undefined;
    }
  }
  //Función para devolver los litros consumidos de un día
  async litrosConsumidosFechaPersonalizada(){
    //console.log(this.endPersonalizado);
    //console.log(this.startPersonalizado);
    //console.log(this.fechaActualPersonalizada);
    if(this.endPersonalizado && this.startPersonalizado){
      console.log(this.verificarDiaActualEnRangoFechas(this.startPersonalizado,this.endPersonalizado,this.fechaActualPersonalizada));
      this.fechaPersonalizadaError = false;
      this.fechaPersonalizada = true;
      this.litrosConsumidosLoadingGif();
      const diaSiguiente = this.obtenerDiaSiguiente(this.endPersonalizado);
      this.startActualizar = this.startPersonalizado;
      this.endActualizar = diaSiguiente; 
      const fechaActualPresente = this.verificarDiaActualEnRangoFechas(this.startPersonalizado,this.endPersonalizado,this.fechaActualPersonalizada);
      if(fechaActualPresente){
        await this.calcularConsumoDiaActual(diaSiguiente);
      }
      this.historicoDiaSubscription = this.deviceService.getMultiHistoric(this.devicesReferences, this.startPersonalizado, diaSiguiente,"0").subscribe({
        next:resp =>{
            for (let i= 0; i < resp.length; i++) {
              let litrosConsumidos = 0;
              if(fechaActualPresente){
                const dispositivo = this.consumoDiaActual.find((dispositivo: any) => dispositivo.deviceId == resp[i].id)
                litrosConsumidos = dispositivo.consumo;
              }
              for (let j= 0; j < resp[i].readers.length; j++) {
                if (resp[i].readers[j] && resp[i].readers[j].field11 !== undefined) {
                  litrosConsumidos += parseFloat(resp[i].readers[j].field11 !== null ? resp[i].readers[j].field11 : 0);
                } else {
                  litrosConsumidos += 0; //Si el valor es undefined, sumamos 0
                }
                if (resp[i].readers[j] && resp[i].readers[j].field12 !== undefined) {
                  litrosConsumidos += parseFloat(resp[i].readers[j].field12 !== null ? resp[i].readers[j].field12 : 0);
                } else {
                  litrosConsumidos += 0; //Si el valor es undefined, sumamos 0
                }
                if (resp[i].readers[j] && resp[i].readers[j].field20 !== undefined) {
                  litrosConsumidos += parseFloat(resp[i].readers[j].field20 !== null ? resp[i].readers[j].field20 : 0);
                } else {
                  litrosConsumidos += 0; //Si el valor es undefined, sumamos 0
                }
              }
              this.litrosConsumidosPorDispositivo[resp[i].dev_reference] = Number(litrosConsumidos.toFixed(2));
            }
          }, error: err => {
            if (err.status == 429) {
              this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
              this.recargarPaginaDespuesDeTiempo();
            } else {
              this.errorMessage = err.error.message;
            }
          },complete: () =>{
            this.calcularLitrosTotales();
          }
        })
    } else {
      this.fechaPersonalizadaError = true;
    }
  }

  //Función igual que fecha personalizada pero pasando las fechas de inicio y fin
  async litrosConsumidosFechaPersonalizadaConFechas(start: string, end: string){
    //this.litrosConsumidosLoadingGif();
    const diaSiguiente = this.obtenerDiaSiguiente(end);
    const fechaActualPresente = this.verificarDiaActualEnRangoFechas(start,end,this.fechaActualPersonalizada);
    if(fechaActualPresente){
      await this.calcularConsumoDiaActual(diaSiguiente);
    }
    this.historicoDiaSubscription = this.deviceService.getMultiHistoric(this.devicesReferences, start, end,"0").subscribe({
      next:resp =>{
        for (let i= 0; i < resp.length; i++) {
          let litrosConsumidos = 0;
          if(fechaActualPresente){
            const dispositivo = this.consumoDiaActual.find((dispositivo: any) => dispositivo.deviceId == resp[i].id)
            litrosConsumidos = dispositivo.consumo;
          }
          for (let j= 0; j < resp[i].readers.length; j++) {
            if (resp[i].readers[j] && resp[i].readers[j].field11 !== undefined) {
              litrosConsumidos += parseFloat(resp[i].readers[j].field11 !== null ? resp[i].readers[j].field11 : 0);
            } else {
              litrosConsumidos += 0; //Si el valor es undefined, sumamos 0
            }
            if (resp[i].readers[j] && resp[i].readers[j].field12 !== undefined) {
              litrosConsumidos += parseFloat(resp[i].readers[j].field12 !== null ? resp[i].readers[j].field12 : 0);
            } else {
              litrosConsumidos += 0; //Si el valor es undefined, sumamos 0
            }
            if (resp[i].readers[j] && resp[i].readers[j].field20 !== undefined) {
              litrosConsumidos += parseFloat(resp[i].readers[j].field20 !== null ? resp[i].readers[j].field20 : 0);
            } else {
              litrosConsumidos += 0; //Si el valor es undefined, sumamos 0
            }
          }
          this.litrosConsumidosPorDispositivo[resp[i].dev_reference] = Number(litrosConsumidos.toFixed(2));
        }
      }, error: err => {
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      },complete: () =>{
        this.calcularLitrosTotales();
      }
    });
  }

  calcularLitrosTotales(){
    let sumaLitrosPorDispositivo = 0;
    for (const dispositivo in this.litrosConsumidosPorDispositivo) {
      if (this.litrosConsumidosPorDispositivo.hasOwnProperty(dispositivo)) {
        const litrosConsumidos = this.litrosConsumidosPorDispositivo[dispositivo];
        if (litrosConsumidos !== undefined) {
          sumaLitrosPorDispositivo += litrosConsumidos;
        }
      }
    }
    this.consumoTotal = sumaLitrosPorDispositivo;
  }

  //Se recarga la página y la llamada que se hace en /home para conseguir los datos de usuario ya maneja el error
  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  verificarDiaActualEnRangoFechas(start: string, end: string, actual: string): boolean {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const currentDate = new Date(actual);
    // Asegúrate de que las fechas sean válidas
    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime()) || isNaN(currentDate.getTime())) {
      throw new Error('Fechas no válidas');
    }
    // Verifica si la fecha actual está dentro del rango
    return currentDate >= startDate && currentDate <= endDate;
  }

  //Hacer la función asyncrona para poder esperar a que termine antes de seguir con el codigo
  async calcularConsumoDiaActual(diaSiguiente: any) {
    return new Promise<void>((resolve, reject) => {
      this.consumoDiaActual = [];
      this.historicoDiaSubscription = this.deviceService.getMultiHistoricRaw(this.devicesReferences, this.fechaActualPersonalizada, diaSiguiente, "0").subscribe({
        next: resp => {
          for (let i = 0; i < resp.length; i++) {
            let consumoDispositivo = 0;
            for (let j = 0; j < resp[i].readers_raw.length; j++) {
              if (resp[i].readers_raw[j] && resp[i].readers_raw[j].field11 !== undefined) {
                consumoDispositivo += parseFloat(resp[i].readers_raw[j].field11 !== null ? resp[i].readers_raw[j].field11 : 0);
              } else {
                consumoDispositivo += 0; //Si el valor es undefined, sumamos 0
              }
              if (resp[i].readers_raw[j] && resp[i].readers_raw[j].field12 !== undefined) {
                consumoDispositivo += parseFloat(resp[i].readers_raw[j].field12 !== null ? resp[i].readers_raw[j].field12 : 0);
              } else {
                consumoDispositivo += 0; //Si el valor es undefined, sumamos 0
              }
              if (resp[i].readers_raw[j] && resp[i].readers_raw[j].field20 !== undefined) {
                consumoDispositivo += parseFloat(resp[i].readers_raw[j].field20 !== null ? resp[i].readers_raw[j].field20 : 0);
              } else {
                consumoDispositivo += 0; //Si el valor es undefined, sumamos 0
              }
            }
            this.consumoDiaActual.push({
              deviceId: resp[i].id,
              consumo: consumoDispositivo
            });
          }
          resolve();
        }, error: err => {
          reject(err);
        }, complete: () => { }
      });
    });
  }
  /****************************************Funciones para formatear fecha****************************************************/
    //Formatear tipo date a año/mes/dia
    formatDateToString(date: Date): string {
      if(!date){
        return "";
      } else{
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
      }
    }
    //Convertir formato 30/07/2023 a 2023-07-30
    convertirFechaFormatoISO(fechaEnFormatoD: string): string {
      const partesFecha = fechaEnFormatoD.split('/');
      const dia = partesFecha[0];
      const mes = partesFecha[1];
      const anio = partesFecha[2];
      const fechaISO = `${anio}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
      return fechaISO;
    }
    //Convertir FechaActualD a formato dd/MM/yy
    convertirFecha(fechaOriginal: string): Date | null {
      const partes = fechaOriginal.split(' ');
      const dia = partes[0];
      const anio = partes[4];
      const mesIndex = this.meses.findIndex((mes) => mes === partes[2]);
      if (mesIndex !== -1) {
        const fechaFormateada = new Date(Number(anio), mesIndex, Number(dia));
        return fechaFormateada;
      }
      return null;
    }
    // Función para convertir el formato de fecha "24 DE JULIO DE 2023" a "2023-07-24"
    convertirFechaFormato(fechaEnFormatoD: string): string {
      const partesFecha = fechaEnFormatoD.split(' ');
      const dia = partesFecha[0];
      const mes = partesFecha[2];
      const anio = partesFecha[4];
      const mesIndex = this.meses.findIndex((m) => m === mes);
      if (mesIndex !== -1) {
        const mesNumero = mesIndex + 1;
        const mesStr = mesNumero < 10 ? '0' + mesNumero : mesNumero.toString();
        const diaStr = dia.length === 1 ? '0' + dia : dia;
        return `${anio}-${mesStr}-${diaStr}`;
      }
      return "";
    }
    //Conseguir fecha actual en formato 19 DE JULIO DE 2023
    formatearFechaD(fecha: Date): string {
      const meses = [
        "ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO",
        "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"
      ];
      const dia = fecha.getDate();
      const mes = meses[fecha.getMonth()];
      const anio = fecha.getFullYear();
      return `${dia} DE ${mes} DE ${anio}`;
    }
    // Función para obtener el día siguiente en formato '2023-07-24'
    obtenerDiaSiguiente(diaActual: string): string {
      const fechaObjeto = new Date(diaActual);
      const diaSiguiente = addDays(fechaObjeto, 1);
      return diaSiguiente.toISOString().slice(0, 10);
    }
    //Se consigue la fecha de la semana en formato 17/07/2023 A 23/07/2023 dependiendo del fechaActualD
    actualizarFechaActualS(fecha: Date) {
      const diaSemana = fecha.getDay(); // 0: Domingo, 1: Lunes, ..., 6: Sábado
      const inicioSemana = new Date(fecha);
      if (diaSemana === 0) {
        inicioSemana.setDate(fecha.getDate() - 6);
      } else {
        inicioSemana.setDate(fecha.getDate() - diaSemana + 1);
      }
      const finSemana = new Date(inicioSemana);
      finSemana.setDate(inicioSemana.getDate() + 6); // Fin de la semana (Domingo)
      const formatoFecha = 'dd/MM/yyyy';
      const inicioSemanaStr = format(inicioSemana, formatoFecha, { locale: es });
      const finSemanaStr = format(finSemana, formatoFecha, { locale: es });
      this.fechaActualS = `${inicioSemanaStr} A ${finSemanaStr}`;
      this.inicioSemana = inicioSemanaStr;
      this.finSemana = finSemanaStr;
      // También se cambia el fechaActualD por el último día de la semana
      const fechaActualDFormateada = this.formatearFechaD(finSemana);
      this.fechaActualD = fechaActualDFormateada;
    }

    //Convertir formato 24/07/2023 a 24 DE JULIO DE 2023
    convertirFechaFormatoLargo(fechaEnFormatoD: string): string {
      let fechaEnFormatoISO = this.convertirFechaFormatoISO(fechaEnFormatoD);
      const fechaObjeto = parseISO(fechaEnFormatoISO);
      const fechaFormateada = format(fechaObjeto, 'dd \'de\' MMMM \'de\' yyyy', { locale: es });
      return fechaFormateada;
    }

    //Convierte formato 2023-07-31 a 31 de Julio de 2023
    convertirFechaPersonalizadaParaPdf(fechaString: string): string {
      const fecha = new Date(fechaString);
      const dia = fecha.getDate();
      const mes = this.mesesPdf[fecha.getMonth()];
      const anio = fecha.getFullYear();
    
      return `${dia} de ${mes} de ${anio}`;
    }

    //Función para personalizar la fecha y ponerla así en el pdf
    convertirFechaFormatoPersonalizado(fechaEnFormatoLargo: string): string {
      const palabras = fechaEnFormatoLargo.split(' ');
      const dia = palabras[0];
      const mes = palabras[2].toUpperCase();
      const ano = palabras[4];
      const mesIndex = this.meses.indexOf(mes);
      const mesFormateado = this.meses[mesIndex].charAt(0) + this.meses[mesIndex].slice(1).toLowerCase();
      return `${dia} de ${mesFormateado} de ${ano}`;
    }

  /****************************************Funciones para actualizar la fecha y calcular los litros****************************************************/

  // Método para calcular el mes correspondiente a fechaActualD y actualizar fechaActualD al último día del mes
  calcularMesFechaActualD() {
    if (this.fechaActualD) {
      const fechaConvertida = this.convertirFecha(this.fechaActualD);
      if (fechaConvertida) {
        const ultimoDiaMes = new Date(fechaConvertida.getFullYear(), fechaConvertida.getMonth() + 1, 0);
        this.fechaActualD = this.formatearFechaD(ultimoDiaMes);
        const mesIndex = fechaConvertida.getMonth();
        this.fechaActualM = `${this.meses[mesIndex]} DE ${fechaConvertida.getFullYear()}`;
      } else {
        console.log('Fecha no válida');
      }
    } else {
      console.log('Fecha actual D es null o no válida');
    }
  }
  // Función para restar un día a fechaActualD
  restarDiaFechaActual() {
    if (this.fechaActualD) {
      const fechaActual = this.convertirFecha(this.fechaActualD);
      if (fechaActual) {
        fechaActual.setDate(fechaActual.getDate() - 1);
        this.fechaActualD = this.formatearFechaD(fechaActual);
        this.litrosConsumidosLoadingGif();
        this.litrosConsumidosDia();
      }
    }
  }
  // Función para sumar un día a fechaActualD
  sumarDiaFechaActual() {
    if (this.fechaActualD) {
      const fechaActual = this.convertirFecha(this.fechaActualD);
      if (fechaActual) {
        fechaActual.setDate(fechaActual.getDate() + 1);
        this.fechaActualD = this.formatearFechaD(fechaActual);
        this.litrosConsumidosLoadingGif();
        this.litrosConsumidosDia();
      }
    }
  }
  // Función para sumar una semana a fechaActualS
  restarSemanaFechaActual() {
    if (this.fechaActualD) {
      const fechaActual = this.convertirFecha(this.fechaActualD);
      if (fechaActual) {
        const nuevaFecha = subWeeks(fechaActual, 1);
        this.actualizarFechaActualS(nuevaFecha);
        this.litrosConsumidosLoadingGif();
        this.litrosConsumidosSemana();
      }
    }
  }
  // Función para sumar una semana a fechaActualS
  sumarSemanaFechaActual() {
    if (this.fechaActualD) {
      const fechaActual = this.convertirFecha(this.fechaActualD);
      if (fechaActual) {
        const nuevaFecha = addWeeks(fechaActual, 1);
        this.actualizarFechaActualS(nuevaFecha);
        this.litrosConsumidosLoadingGif();
        this.litrosConsumidosSemana();
      }
    }
  }
  // Método para cambiar al mes anterior
  cambiarMesAnterior() {
    const fechaActual = this.convertirFecha(this.fechaActualD);
    if (fechaActual) {
      const mesAnterior = subMonths(fechaActual, 1);
      this.actualizarFechaActualM(mesAnterior);
      this.litrosConsumidosLoadingGif();
      this.litrosConsumidosMes();
    }
  }
  // Método para cambiar al mes siguiente
  cambiarMesSiguiente() {
    const fechaActual = this.convertirFecha(this.fechaActualD);
    if (fechaActual) {
      const mesSiguiente = addMonths(fechaActual, 1);
      this.actualizarFechaActualM(mesSiguiente);
      this.litrosConsumidosLoadingGif();
      this.litrosConsumidosMes();
    }
  }
  //Función para actualizar la fecha del mes y de la semana
  actualizarFechaActualM(fecha: Date) {
    const inicioMes = startOfWeek(fecha, { weekStartsOn: 1 });
    const finMes = endOfMonth(fecha);
    const formatoFecha = 'dd/MM/yyyy';
    const inicioMesStr = format(inicioMes, formatoFecha, { locale: es });
    const finMesStr = format(finMes, formatoFecha, { locale: es });
    this.fechaActualS = `${inicioMesStr} A ${finMesStr}`;
    // Formatear fecha en formato 'MES DEL ANIO'
    const mesActualStr = format(fecha, 'MMMM', { locale: es }).toUpperCase();
    const anioActualStr = format(fecha, 'yyyy');
    this.fechaActualM = `${mesActualStr} DEL ${anioActualStr}`;
    this.fechaActualD = this.formatearFechaD(finMes);
  }

  //Ver si un dispositivo está online comprobando que su ultimo historico es de hace por lo menos media hora
  getDeviceStatus(lastReadTime: string): string {
    const lastReadDate = new Date(lastReadTime);
    const currentDate = new Date();
    // Obtener la fecha actual menos 30 minutos
    const halfHourAgo = subMinutes(currentDate, 30);
    // Comparar si la fecha de la última lectura está antes de la fecha actual menos 30 minutos
    if (isBefore(lastReadDate, halfHourAgo)) {
      return "offline";
    } else {
      return "online";
    }
  }

  parseJSONOptions(dev_option_value: string) {
    const options = JSON.parse(dev_option_value);
    return options.beertype1
  }

  //Función para generar el informe del dispositivo en formato PDF
  async generatePDF(dev_label: string, dev_reference:string, dev_option_value: string, litros: string | 0) {
    //Conseguir la fecha para escribirla en el pdf
    let options = JSON.parse(dev_option_value);
    console.log(options);
    const cervezaEncontrada = this.cervezas.find(cerveza => cerveza.value === parseInt(options.beertype1));
    console.log(cervezaEncontrada);
    let beertypeString = "";
    if (cervezaEncontrada) {
      beertypeString = cervezaEncontrada.name;
    } else {
      beertypeString = "Indefinido"; // O cualquier otro valor predeterminado
    }
    let fechaInicioString = "";
    let fechaFinString = "";
    if (this.fechaPersonalizada == true) {
      fechaInicioString = this.convertirFechaPersonalizadaParaPdf(this.startPersonalizado);
      fechaFinString = this.convertirFechaPersonalizadaParaPdf(this.endPersonalizado);
    } else {
      if(this.diario){
        fechaInicioString = this.convertirFechaFormatoPersonalizado(this.fechaActualD);
        fechaFinString = this.convertirFechaFormatoPersonalizado(this.fechaActualD);
      }
      if (this.semanal){
        fechaInicioString = this.convertirFechaFormatoPersonalizado(this.convertirFechaFormatoLargo(this.inicioSemana));
        console.log(fechaInicioString);
        fechaFinString = this.convertirFechaFormatoPersonalizado(this.convertirFechaFormatoLargo(this.finSemana));
        console.log(fechaFinString);
      }
      if(this.mensual){
        fechaInicioString = this.convertirFechaFormatoPersonalizado(this.inicioMes);
        fechaFinString = this.convertirFechaFormatoPersonalizado(this.finMes);
      }
    }
    const pdfDoc = await PDFDocument.create();
    const page = pdfDoc.addPage([600, 800]);
    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
    const fontBold = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
    const fontSize = 12;
    const grisClaro = rgb(119 / 255, 119 / 255, 119 / 255); // Color gris oscuro (#777)
    const grisOscuro = rgb(51 / 255, 51 / 255, 51 / 255); //(#333)
    /*************************************Texto a la derecha***********************************************/
    //PERIODO DE CONSUMO
      const periodoText = 'Periodo de consumo';
      const periodoTextWidth = fontBold.widthOfTextAtSize(periodoText, fontSize);
      page.drawText(periodoText, {
        x: 530 - periodoTextWidth,
        y: page.getHeight() - 90,
        size: fontSize,
        color: grisOscuro,
        font: fontBold,
        lineHeight: 20, 
      });
      const fechaInicio = 'De: '+fechaInicioString;
      const fechaFin = 'A: '+fechaFinString;
      const fechaInicioWidth = font.widthOfTextAtSize(fechaInicio, fontSize);
      const fechaFinWidth = font.widthOfTextAtSize(fechaFin, fontSize);
      page.drawText(fechaInicio, {
        x: 530 - fechaInicioWidth,
        y: page.getHeight() - 110,
        size: fontSize,
        color: grisClaro,
        font: font,
        lineHeight: 20,
      });
      page.drawText(fechaFin, {
        x: 530 - fechaFinWidth,
        y: page.getHeight() - 130,
        size: fontSize,
        color: grisClaro,
        font: font,
        lineHeight: 20,
      });
    //DISPOSITIVO
      const dispositivo = 'Dispositivo';
      const dispositivoWidth = fontBold.widthOfTextAtSize(dispositivo, fontSize);
      page.drawText(dispositivo, {
        x: 530 - dispositivoWidth,
        y: page.getHeight() - 220,
        size: fontSize,
        color: grisOscuro,
        font: fontBold,
        lineHeight: 20, // Increase the line height to move to the next line
      });
      const mercadoCanalejas = 'Mercado Canalejas Madrid';
      const mercadoCanalejasWidth = font.widthOfTextAtSize(mercadoCanalejas, fontSize);
      page.drawText(mercadoCanalejas, {
        x: 530 - mercadoCanalejasWidth,
        y: page.getHeight() - 240,
        size: fontSize,
        color: grisClaro,
        font: font,
        lineHeight: 20, // Increase the line height to move to the next line
      });
      const dev_labelS = dev_label;
      const dev_labelSWidth = font.widthOfTextAtSize(dev_labelS, fontSize);
      page.drawText(dev_labelS, {
        x: 530 - dev_labelSWidth,
        y: page.getHeight() - 260,
        size: fontSize,
        color: grisClaro,
        font: font,
        lineHeight: 20, // Increase the line height to move to the next line
      });
      const dev_referenceS = dev_reference;
      const dev_referenceSWidth = font.widthOfTextAtSize(dev_referenceS, fontSize);
      page.drawText(dev_referenceS, {
        x: 530 - dev_referenceSWidth,
        y: page.getHeight() - 280,
        size: fontSize,
        color: grisClaro,
        font: font,
        lineHeight: 20, // Increase the line height to move to the next line
      });
    //LITROS
      const volumen = "Volumen (Litros)";
      const volumenWidth = fontBold.widthOfTextAtSize(volumen, fontSize);
      page.drawText(volumen, {
        x: 530 - volumenWidth,
        y: page.getHeight() - 340,
        size: fontSize,
        color: grisOscuro,
        font: fontBold,
        lineHeight: 20, // Increase the line height to move to the next line
      });
      if(litros !== null && litros !== undefined){
        const litrosS = litros.toString();
        const litrosWidth = font.widthOfTextAtSize(litrosS, fontSize);
        page.drawText(litrosS, {
          x: 530 - litrosWidth,
          y: page.getHeight() - 360,
          size: fontSize,
          color: grisClaro,
          font: font,
          lineHeight: 20, // Increase the line height to move to the next line
        });
      }
      if(litros !== null && litros !== undefined){
        const litrosTotal = "Total: "+litros.toString();
        const litrosTotalWidth = fontBold.widthOfTextAtSize(litrosTotal, fontSize);
        page.drawText(litrosTotal, {
          x: 530 - litrosTotalWidth,
          y: page.getHeight() - 400,
          size: fontSize,
          color: grisOscuro,
          font: fontBold,
          lineHeight: 20, // Increase the line height to move to the next line
        });
      }
    /*************************************Texto a la izqueirda***********************************************/
    //IMAGEN
      const imageUrl = 'assets/images/canalejas/logo-EG.png';
      const imageBytes = await fetch(imageUrl).then((res) => res.arrayBuffer());
      const image = await pdfDoc.embedPng(imageBytes);
      const imageWidth = 115;
      const imageHeight = 100;
      page.drawImage(image, {
        x: 70,
        y: page.getHeight() - 160, // Arriba de la página
        width: imageWidth,
        height: imageHeight,
      });
    //PROVEEDOR
      const proveedorText = 'Proveedor:';
      page.drawText(proveedorText, {
        x: 70,
        y: page.getHeight() - 220,
        size: fontSize,
        color: grisOscuro,
        font: fontBold,
        lineHeight: 20,
      });
      const proveedorValue = 'Hijos de Rivera, S.A.U';
      page.drawText(proveedorValue, {
        x: 70,
        y: page.getHeight() - 240,
        size: fontSize,
        color: grisClaro,
        font: font,
        lineHeight: 20,
      });
      const cifText = 'CIF - A15002637';
      page.drawText(cifText, {
        x: 70,
        y: page.getHeight() - 260,
        size: fontSize,
        color: grisClaro,
        font: font,
        lineHeight: 20,
      });
      const email = 'info@estrellagalicia.com';
      page.drawText(email, {
        x: 70,
        y: page.getHeight() - 280,
        size: fontSize,
        color: grisClaro,
        font: font,
        lineHeight: 20,
      });
    //CONCEPTO
      const concepto = 'Concepto';
      page.drawText(concepto, {
        x: 70,
        y: page.getHeight() - 340,
        size: fontSize,
        color: grisOscuro,
        font: fontBold,
        lineHeight: 20,
      });
      const litrosConsumidosText = 'Litros consumidos';
      page.drawText(litrosConsumidosText, {
        x: 70,
        y: page.getHeight() - 360,
        size: fontSize,
        color: grisClaro,
        font: font,
        lineHeight: 20,
      });
      const tipoCerveza = 'Cerveza: ' +beertypeString;
      page.drawText(tipoCerveza, {
        x: 70,
        y: page.getHeight() - 380,
        size: fontSize,
        color: grisClaro,
        font: font,
        lineHeight: 20,
      });
    /*************************************Pie de página***********************************************/
      const numPaginas = pdfDoc.getPageCount();
      const dataMonitoring = 'DATA MONITORING SL';
      const iotSolutions = 'IoT Solutions';
      const paginas = numPaginas + '/' + numPaginas;
      const dataMonitoringWidth = font.widthOfTextAtSize(dataMonitoring, fontSize);
      const iotSolutionsWidth = font.widthOfTextAtSize(iotSolutions, fontSize);
      const paginasWidth = font.widthOfTextAtSize(paginas, fontSize);
      const pageCount = pdfDoc.getPageCount();
      const currentPage = pdfDoc.getPage(pageCount - 1);
      const centeredX1 = (page.getWidth() - dataMonitoringWidth) / 2;
      const centeredX2 = (page.getWidth() - iotSolutionsWidth) / 2;
      currentPage.drawText(dataMonitoring, {
        x: centeredX1,
        y: 50,
        size: fontSize,
        color: grisOscuro,
        font: fontBold,
        lineHeight: 20,
      });
      currentPage.drawText(iotSolutions, {
        x: centeredX2,
        y: 30,
        size: fontSize,
        color: grisClaro,
        font: font,
        lineHeight: 20,
      });
      currentPage.drawText(paginas, {
        x: 530 - paginasWidth,
        y: 30,
        size: fontSize,
        color: grisClaro,
        font: fontBold,
        lineHeight: 20,
      });
    /*************************************Decoración***********************************************/
      page.drawRectangle({
        x: 65,
        y: page.getHeight() - 345,
        width: 470,
        height: 20,
        color: grisClaro,
        opacity: 0.2,
      });

    const pdfBytes = await pdfDoc.save();
    const pdfBlob = new Blob([pdfBytes], { type: 'application/pdf' });
    const downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(pdfBlob);
    downloadLink.download = 'Informe-Consumo '+dev_label+'.pdf';
    downloadLink.click();
  }
  //Función para generar informe completo
  async generatePDFCompleto() {
    let fechaInicioString = "";
    let fechaFinString = "";
    if (this.fechaPersonalizada == true) {
      fechaInicioString = this.convertirFechaPersonalizadaParaPdf(this.startPersonalizado);
      fechaFinString = this.convertirFechaPersonalizadaParaPdf(this.endPersonalizado);
    } else {
      if(this.diario){
        fechaInicioString = this.convertirFechaFormatoPersonalizado(this.fechaActualD);
        fechaFinString = this.convertirFechaFormatoPersonalizado(this.fechaActualD);
      }
      if (this.semanal){
        fechaInicioString = this.convertirFechaFormatoPersonalizado(this.convertirFechaFormatoLargo(this.inicioSemana));
        fechaFinString = this.convertirFechaFormatoPersonalizado(this.convertirFechaFormatoLargo(this.finSemana));
      }
      if(this.mensual){
        fechaInicioString = this.convertirFechaFormatoPersonalizado(this.inicioMes);
        fechaFinString = this.convertirFechaFormatoPersonalizado(this.finMes);
      }
    }
    const numPaginas = this.mercadoCanalejasDevices.length;
    const pdfDoc = await PDFDocument.create();
    for (let pageIndex = 0; pageIndex < numPaginas; pageIndex++) {
    //Conseguir la fecha para escribirla en el pdf
      let options = JSON.parse(this.mercadoCanalejasDevices[pageIndex].options[0].dev_option_value);
      //console.log(options);
      const cervezaEncontrada = this.cervezas.find(cerveza => cerveza.value === parseInt(options.beertype1));
      //console.log(cervezaEncontrada);
      let beertypeString = "";
      if (cervezaEncontrada) {
        beertypeString = cervezaEncontrada.name;
      } else {
        beertypeString = "Indefinido"; // O cualquier otro valor predeterminado
      }
      /*if(options.beertype1=="1"||options.beertype1==undefined){
        beertypeString = "Estrella Galicia";
      }
      if(options.beertype1=="2"){
        beertypeString = "Estrella Galicia 1906";
      }*/
      const page = pdfDoc.addPage([600, 800]);
      const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
      const fontBold = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
      const fontSize = 12;
      const grisClaro = rgb(119 / 255, 119 / 255, 119 / 255); // Color gris oscuro (#777)
      const grisOscuro = rgb(51 / 255, 51 / 255, 51 / 255); //(#333)
        /*************************************Texto a la derecha***********************************************/
        //PERIODO DE CONSUMO
          const periodoText = 'Periodo de consumo';
          const periodoTextWidth = fontBold.widthOfTextAtSize(periodoText, fontSize);
          page.drawText(periodoText, {
            x: 530 - periodoTextWidth,
            y: page.getHeight() - 90,
            size: fontSize,
            color: grisOscuro,
            font: fontBold,
            lineHeight: 20, 
          });
          const fechaInicio = 'De: '+fechaInicioString;
          const fechaFin = 'A: '+fechaFinString;
          const fechaInicioWidth = font.widthOfTextAtSize(fechaInicio, fontSize);
          const fechaFinWidth = font.widthOfTextAtSize(fechaFin, fontSize);
          page.drawText(fechaInicio, {
            x: 530 - fechaInicioWidth,
            y: page.getHeight() - 110,
            size: fontSize,
            color: grisClaro,
            font: font,
            lineHeight: 20,
          });
          page.drawText(fechaFin, {
            x: 530 - fechaFinWidth,
            y: page.getHeight() - 130,
            size: fontSize,
            color: grisClaro,
            font: font,
            lineHeight: 20,
          });
        //DISPOSITIVO
          const dispositivo = 'Dispositivo';
          const dispositivoWidth = fontBold.widthOfTextAtSize(dispositivo, fontSize);
          page.drawText(dispositivo, {
            x: 530 - dispositivoWidth,
            y: page.getHeight() - 220,
            size: fontSize,
            color: grisOscuro,
            font: fontBold,
            lineHeight: 20, // Increase the line height to move to the next line
          });
          const mercadoCanalejas = 'Mercado Canalejas Madrid';
          const mercadoCanalejasWidth = font.widthOfTextAtSize(mercadoCanalejas, fontSize);
          page.drawText(mercadoCanalejas, {
            x: 530 - mercadoCanalejasWidth,
            y: page.getHeight() - 240,
            size: fontSize,
            color: grisClaro,
            font: font,
            lineHeight: 20, // Increase the line height to move to the next line
          });
          const dev_labelS = this.mercadoCanalejasDevices[pageIndex].dev_label;
          const dev_labelSWidth = font.widthOfTextAtSize(dev_labelS, fontSize);
          page.drawText(dev_labelS, {
            x: 530 - dev_labelSWidth,
            y: page.getHeight() - 260,
            size: fontSize,
            color: grisClaro,
            font: font,
            lineHeight: 20, // Increase the line height to move to the next line
          });
          const dev_referenceS = this.mercadoCanalejasDevices[pageIndex].dev_reference;
          const dev_referenceSWidth = font.widthOfTextAtSize(dev_referenceS, fontSize);
          page.drawText(dev_referenceS, {
            x: 530 - dev_referenceSWidth,
            y: page.getHeight() - 280,
            size: fontSize,
            color: grisClaro,
            font: font,
            lineHeight: 20, // Increase the line height to move to the next line
          });
        //LITROS
          const volumen = "Volumen (Litros)";
          const volumenWidth = fontBold.widthOfTextAtSize(volumen, fontSize);
          page.drawText(volumen, {
            x: 530 - volumenWidth,
            y: page.getHeight() - 340,
            size: fontSize,
            color: grisOscuro,
            font: fontBold,
            lineHeight: 20, // Increase the line height to move to the next line
          });
          const litrosValue = this.litrosConsumidosPorDispositivo[this.mercadoCanalejasDevices[pageIndex].dev_reference!];
          if(this.litrosConsumidosPorDispositivo[this.mercadoCanalejasDevices[pageIndex].dev_reference] !== null && 
            this.litrosConsumidosPorDispositivo[this.mercadoCanalejasDevices[pageIndex].dev_reference] !== undefined &&
            this.mercadoCanalejasDevices[pageIndex].dev_reference !== undefined && 
            this.mercadoCanalejasDevices[pageIndex] !== undefined &&
            litrosValue !== undefined && litrosValue !== null){
            const litrosS = this.soloDosDecimalesConComa(litrosValue);
            const litrosWidth = font.widthOfTextAtSize(litrosS, fontSize);
            page.drawText(litrosS, {
              x: 530 - litrosWidth,
              y: page.getHeight() - 360,
              size: fontSize,
              color: grisClaro,
              font: font,
              lineHeight: 20, // Increase the line height to move to the next line
            });
          }
          const litrosTotalesValue = this.litrosConsumidosPorDispositivo[this.mercadoCanalejasDevices[pageIndex].dev_reference!];
          if(this.litrosConsumidosPorDispositivo[this.mercadoCanalejasDevices[pageIndex].dev_reference] !== null && 
            this.litrosConsumidosPorDispositivo[this.mercadoCanalejasDevices[pageIndex].dev_reference] !== undefined &&
            this.mercadoCanalejasDevices[pageIndex].dev_reference !== undefined && 
            this.mercadoCanalejasDevices[pageIndex] !== undefined &&
            litrosTotalesValue !== undefined && litrosTotalesValue !== null){
            const litrosS = 'Total: ' +this.soloDosDecimalesConComa(litrosTotalesValue);
            const litrosWidth = fontBold.widthOfTextAtSize(litrosS, fontSize);
            page.drawText(litrosS, {
              x: 530 - litrosWidth,
              y: page.getHeight() - 400,
              size: fontSize,
              color: grisOscuro,
              font: fontBold,
              lineHeight: 20, // Increase the line height to move to the next line
            });
          }
        /*************************************Texto a la izqueirda***********************************************/
        //IMAGEN
          const imageUrl = 'assets/images/canalejas/logo-EG.png';
          const imageBytes = await fetch(imageUrl).then((res) => res.arrayBuffer());
          const image = await pdfDoc.embedPng(imageBytes);
          const imageWidth = 115;
          const imageHeight = 100;
          page.drawImage(image, {
            x: 70,
            y: page.getHeight() - 160, // Arriba de la página
            width: imageWidth,
            height: imageHeight,
          });
        //PROVEEDOR
          const proveedorText = 'Proveedor:';
          page.drawText(proveedorText, {
            x: 70,
            y: page.getHeight() - 220,
            size: fontSize,
            color: grisOscuro,
            font: fontBold,
            lineHeight: 20,
          });
          const proveedorValue = 'Hijos de Rivera, S.A.U';
          page.drawText(proveedorValue, {
            x: 70,
            y: page.getHeight() - 240,
            size: fontSize,
            color: grisClaro,
            font: font,
            lineHeight: 20,
          });
          const cifText = 'CIF - A15002637';
          page.drawText(cifText, {
            x: 70,
            y: page.getHeight() - 260,
            size: fontSize,
            color: grisClaro,
            font: font,
            lineHeight: 20,
          });
          const email = 'info@estrellagalicia.com';
          page.drawText(email, {
            x: 70,
            y: page.getHeight() - 280,
            size: fontSize,
            color: grisClaro,
            font: font,
            lineHeight: 20,
          });
        //CONCEPTO
          const concepto = 'Concepto';
          page.drawText(concepto, {
            x: 70,
            y: page.getHeight() - 340,
            size: fontSize,
            color: grisOscuro,
            font: fontBold,
            lineHeight: 20,
          });
          const litrosConsumidosText = 'Litros consumidos';
          page.drawText(litrosConsumidosText, {
            x: 70,
            y: page.getHeight() - 360,
            size: fontSize,
            color: grisClaro,
            font: font,
            lineHeight: 20,
          });
          const tipoCerveza = 'Cerveza: ' +beertypeString;
          page.drawText(tipoCerveza, {
            x: 70,
            y: page.getHeight() - 380,
            size: fontSize,
            color: grisClaro,
            font: font,
            lineHeight: 20,
          });
        /*************************************Pie de página***********************************************/
          const dataMonitoring = 'DATA MONITORING SL';
          const iotSolutions = 'IoT Solutions';
          const paginas = `${pageIndex + 1} / ${numPaginas}`;
          const dataMonitoringWidth = font.widthOfTextAtSize(dataMonitoring, fontSize);
          const iotSolutionsWidth = font.widthOfTextAtSize(iotSolutions, fontSize);
          const paginasWidth = font.widthOfTextAtSize(paginas, fontSize);
          const pageCount = pdfDoc.getPageCount();
          const currentPage = pdfDoc.getPage(pageCount - 1);
          const centeredX1 = (page.getWidth() - dataMonitoringWidth) / 2;
          const centeredX2 = (page.getWidth() - iotSolutionsWidth) / 2;
          currentPage.drawText(dataMonitoring, {
            x: centeredX1,
            y: 50,
            size: fontSize,
            color: grisOscuro,
            font: fontBold,
            lineHeight: 20,
          });
          currentPage.drawText(iotSolutions, {
            x: centeredX2,
            y: 30,
            size: fontSize,
            color: grisClaro,
            font: font,
            lineHeight: 20,
          });
          currentPage.drawText(paginas, {
            x: 530 - paginasWidth,
            y: 30,
            size: fontSize,
            color: grisClaro,
            font: fontBold,
            lineHeight: 20,
          });
        /*************************************Decoración***********************************************/
          page.drawRectangle({
            x: 65,
            y: page.getHeight() - 345,
            width: 470,
            height: 20,
            color: grisClaro,
            opacity: 0.2,
          });
    }

    const pdfBytes = await pdfDoc.save();
    const pdfBlob = new Blob([pdfBytes], { type: 'application/pdf' });
    const downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(pdfBlob);
    downloadLink.download = 'Informe-Consumo-Completo.pdf';
    downloadLink.click();
  }
  
}

